/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomQuizCreateRequest } from '../models/CustomQuizCreateRequest';
import type { CustomQuizCreateResponse } from '../models/CustomQuizCreateResponse';
import type { CustomQuizDetailDefinitionDTO } from '../models/CustomQuizDetailDefinitionDTO';
import type { CustomQuizDTO } from '../models/CustomQuizDTO';
import type { EditCustomQuizDetailResponse } from '../models/EditCustomQuizDetailResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CustomQuizService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Gets a list of custom quizzes
     * Gets a list of custom quizzes
     * @returns CustomQuizDTO OK
     * @throws ApiError
     */
    public getCustomQuizzes({
        locationId,
    }: {
        /**
         * Optionally filter by 1 or more location ids. This query param is repeatable
         */
        locationId?: Array<string>,
    }): CancelablePromise<Array<CustomQuizDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/quiz',
            query: {
                'locationId': locationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Create a custom quiz
     * @returns CustomQuizCreateResponse Success; Created
     * @throws ApiError
     */
    public createCustomQuiz({
        requestBody,
    }: {
        requestBody: CustomQuizCreateRequest,
    }): CancelablePromise<CustomQuizCreateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/quiz',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Edit a custom quiz
     * @returns EditCustomQuizDetailResponse OK
     * @throws ApiError
     */
    public updateCustomQuiz({
        requestBody,
    }: {
        requestBody: CustomQuizDetailDefinitionDTO,
    }): CancelablePromise<EditCustomQuizDetailResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/quiz',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete custom quiz
     * @returns any OK
     * @throws ApiError
     */
    public deleteCustomQuiz({
        customQuizId,
    }: {
        /**
         * ID of the custom quiz
         */
        customQuizId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/quiz/{customQuizId}',
            path: {
                'customQuizId': customQuizId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Get custom quiz details
     * @returns CustomQuizDetailDefinitionDTO Success
     * @throws ApiError
     */
    public getCustomQuizDetails({
        customQuizId,
    }: {
        /**
         * ID of the custom quiz
         */
        customQuizId: string,
    }): CancelablePromise<CustomQuizDetailDefinitionDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/quiz/{customQuizId}',
            path: {
                'customQuizId': customQuizId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

}
